import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import AdminLayout from "../../components/layout/AdminLayout/AdminLayout";
import ImageUploader from "../../components/common/ImageUploader/ImageUploader";
import UploadModules from "../../constants/uploadModules";
import galleryService from "../../services/gallery/galleryService";

import "./Gallery.css";

export default function GalleryForm() {

    const navigate = useNavigate();

    const { id } = useParams();

    const isEdit = !!id;

    const [loading, setLoading] = useState(false);

    const [form, setForm] = useState({

    title: "",

    category: "",

    description: "",

    photoName: "",

    displayOrder: 0,

    isActive: true

});

    useEffect(() => {

        if (isEdit) {

            loadGallery();

        }

    }, []);

    const loadGallery = async () => {

        try {

            setLoading(true);

            const response = await galleryService.getById(id);
            const data = response.data;

            console.log("Image Path:", data.photoName);

if (response.success) {

    const data = response.data;

    setForm({

        title: data.title || "",

        category: data.category || "",

        description: data.description || "",

        photoName: data.photoName || "",

        displayOrder: data.displayOrder || 0,

        isActive: data.isActive

    });

}

        }
        catch (error) {

            console.log(error);

        }
        finally {

            setLoading(false);

        }

    };

    const handleChange = (e) => {

        const { name, value, type, checked } = e.target;

        setForm({

            ...form,

            [name]: type === "checkbox" ? checked : value

        });

    };


    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!form.title.trim()) {

    toast.error("Title is required.");

    return;

}

        try {

            setLoading(true);

            let response;

            if (isEdit) {

                response = await galleryService.update(id, form);

            }
            else {

                response = await galleryService.create(form);

            }

            if (response.success) {

                toast.success(response.message);

                navigate("/gallery");

            }
            else {

                toast.error(response.message);

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Something went wrong.");

        }
        finally {

            setLoading(false);

        }

    };
    return (

        <AdminLayout>

            <div className="page-header">

                <h2>
                    {isEdit ? "Edit Gallery" : "Add Gallery"}
                </h2>

            </div>

            <div className="card">

                <form onSubmit={handleSubmit}>

                    <div className="card-body">

                        <div className="row g-3">

    {/* Gallery Title */}
    <div className="col-lg-6">

        <label className="form-label">
            Gallery Title <span className="text-danger">*</span>
        </label>

        <input
            type="text"
            className="form-control"
            name="title"
            value={form.title}
            onChange={handleChange}
        />

    </div>

    {/* Category */}
    <div className="col-lg-3">

        <label className="form-label">
            Category
        </label>

        <input
            type="text"
            className="form-control"
            name="category"
            value={form.category}
            onChange={handleChange}
        />

    </div>

    {/* Display Order */}
    <div className="col-lg-3">

        <label className="form-label">
            Display Order
        </label>

        <input
            type="number"
            className="form-control"
            name="displayOrder"
            value={form.displayOrder}
            onChange={handleChange}
        />

    </div>

    {/* Description */}
    <div className="col-12">

        <label className="form-label">
            Description
        </label>

        <textarea
            rows="5"
            className="form-control"
            name="description"
            value={form.description}
            onChange={handleChange}
        />

    </div>

    {/* Gallery Image */}
    <div className="col-lg-8">

        <label className="form-label">
            Gallery Image
        </label>

        <ImageUploader
            module={UploadModules.GALLERY}
            value={form.photoName}
            onUpload={(path) =>
                setForm({
                    ...form,
                    photoName: path
                })
            }
        />

    </div>

    {/* Status */}
    <div className="col-lg-4 d-flex align-items-end">

        <div className="form-check mb-2">

            <input
                type="checkbox"
                className="form-check-input"
                id="isActive"
                name="isActive"
                checked={form.isActive}
                onChange={handleChange}
            />

            <label
                className="form-check-label"
                htmlFor="isActive"
            >
                Active
            </label>

        </div>

    </div>

</div>

                        <hr />

                        <div className="d-flex justify-content-start gap-2">

                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => navigate("/gallery")}
                            >
                                Cancel
                            </button>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}
                            >
                                {loading
                                    ? "Saving..."
                                    : isEdit
                                        ? "Update"
                                        : "Save"}
                            </button>

                        </div>

                    </div>

                </form>

            </div>
        </AdminLayout>

    );

}